"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var StringUtils_1 = require("./StringUtils");
var isValidMoment = function (value) {
    return value && value.isValid() ? true : false;
};
exports.isValidMoment = isValidMoment;
var isMomentAfter = function (value, test, inclusive) {
    if (inclusive === void 0) { inclusive = true; }
    if (isValidMoment(test)) {
        if (isValidMoment(value)) {
            return inclusive ? value.isSameOrAfter(test) : value.isAfter(test);
        }
        return false;
    }
    return true;
};
exports.isMomentAfter = isMomentAfter;
var isDateAfter = function (value, test, inclusive) {
    if (inclusive === void 0) { inclusive = true; }
    return isMomentAfter(value ? moment(value) : null, test ? moment(test) : null, inclusive);
};
exports.isDateAfter = isDateAfter;
var isMomentBefore = function (value, test, inclusive) {
    if (inclusive === void 0) { inclusive = true; }
    if (isValidMoment(test)) {
        if (isValidMoment(value)) {
            return inclusive ? value.isSameOrBefore(test) : value.isBefore(test);
        }
        return false;
    }
    return true;
};
exports.isMomentBefore = isMomentBefore;
var isDateBefore = function (value, test, inclusive) {
    if (inclusive === void 0) { inclusive = true; }
    return isMomentBefore(value ? moment(value) : null, test ? moment(test) : null, inclusive);
};
exports.isDateBefore = isDateBefore;
var momentFromString = function (value, format) {
    return StringUtils_1.isNotBlank(value) ? moment(value, format, true) : undefined;
};
exports.momentFromString = momentFromString;
var momentToString = function (value, format) {
    return isValidMoment(value) ? value.format(format) : undefined;
};
exports.momentToString = momentToString;
var dateToString = function (value, format) {
    return momentToString(value ? moment(value) : undefined, format);
};
exports.dateToString = dateToString;
var dateFromString = function (value, format) {
    var m = momentFromString(value, format);
    return isValidMoment(m) ? m.toDate() : undefined;
};
exports.dateFromString = dateFromString;
var momentToISOString = function (value) {
    return value ? value.toISOString() : undefined;
};
exports.momentToISOString = momentToISOString;
var dateToISOString = function (value) {
    return value ? momentToISOString(moment(value)) : undefined;
};
exports.dateToISOString = dateToISOString;
var io = function (value, inFormat, outFormat) {
    return momentToString(momentFromString(value, inFormat), outFormat);
};
exports.io = io;
